import type { ReactNode } from 'react';

/** Tela centralizada das páginas de entrada (login, 2FA, recuperação). */
export default function AuthLayout({ children, brand = 'medicoonline' }: { children: ReactNode; brand?: 'medicoonline' | 'azanas' }) {
  return (
    <main className="auth-page">
      <div className="auth-card fade-in">
        <img className="logo" src={brand === 'medicoonline' ? '/logo-medicoonline.png' : '/logo-healthtech.png'} alt={brand === 'medicoonline' ? 'Médico Online' : 'Azanas'} />
        {children}
      </div>
    </main>
  );
}
